module.exports = __webpack_public_path__ + "static/media/edit-pencil-blue.0301d94f.svg";